import { render } from "./price-input.vue?vue&type=template&id=363ebe18&ts=true"
import script from "./price-input.vue?vue&type=script&lang=ts"
export * from "./price-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__